import React from 'react';
import * as d3 from "./d3.modified.js";
import UberLink from './UberLink';
import UberNode from './UberNode';

export default class Uber extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            nodesData: [],
            linksData: [],
            nodesHashTable: {},
            linksHashTable: {},
        }

        this.event = {
            startNode: undefined,
            endNode: undefined,
        },

        this.nodeCounter = 0
        this.linkCounter = 0

        this._refs = {}
    }

    testLinkage = (_from, _to, testIfAlreadyExists=false) => {
        if (_from == _to) {
            return false
        }

        if (testIfAlreadyExists) {
            var exists = false
            this.state.nodesData[this.state.nodesHashTable[_from]].links.forEach(
                linkId => {
                    var link = this.state.linksData[this.state.linksHashTable[linkId]]
                    if (link.from_id == _from) {
                        exists = exists || (link.to_id == _to)
                    }
                }
            )
            if (exists)
                return false
        }

        // console.log(this.state.nodesData[this.state.nodesHashTable[_from]], this.state.nodesData[this.state.nodesHashTable[_to]])

        var res = true
        this.state.nodesData[this.state.nodesHashTable[_to]].links.forEach(
            linkId => {
                var link = this.state.linksData[this.state.linksHashTable[linkId]]
                if (link.from_id == _to) {
                    res = res && this.testLinkage(_from, link.to_id)}
                }
        )
        return res
    }

    createUberNode = (_type='match', cb=null) => {

        var _hasInput   = (_type=='union')
                        ||(_type=='intersect')
                        ||(_type=='link')
                        ||(_type=='group')

        var _hasOutput  = (_type=='match')
                        ||(_type=='union')
                        ||(_type=='intersect')
                        ||(_type=='link')

        var _value = ''
        var x = 0
        var y = 0
        if (_type=='match') { _value = ``; x = 10  }
        if (_type=='union') { _value = `union ${this.nodeCounter}`; x=300 }
        if (_type=='intersect') { _value = `same ${this.nodeCounter}`; x=400 }
        if (_type=='link') { _value = 1; x=500 }
        if (_type=='group') { _value = ''; x=630 }

        y = 20
        for (var i=0; i<this.state.nodesData.length; i++) {
            var _nd = this.state.nodesData[i]
            if (x>=_nd.x-250 && x<=_nd.x+_nd.bb.width && _nd.y - y < 50) {
                y += 50
            }
        }

        this.state.nodesData.push({
            id: this.nodeCounter++,
            fieldName: (_type=='match'?'all':null),
            value: _value,
            invert: false,
            hasInput: _hasInput,
            hasOutput: _hasOutput,
            type: _type,
            x: x,
            y: y,
            links: [],
        })

        this.state.nodesHashTable[this.state.nodesData[this.state.nodesData.length-1].id] = this.state.nodesData.length-1

        this.setState({nodesData: this.state.nodesData}, ()=>{if(cb){cb()}})

        return this.state.nodesData[this.state.nodesData.length-1]
    }

    moveNode = (node) => {
        node._styleMove()

        for (var i=0; i<node.links.length; i++) {
            var link = this.state.linksData[this.state.linksHashTable[node.links[i]]]
            if (link.from_id===node.id) {
                link.x1 = node.outputX + node.x
                link.y1 = node.outputY + node.y
            }
            if (link.to_id===node.id) {
                link.x2 = node.inputX + node.x
                link.y2 = node.inputY + node.y
            }
        }
        this.setState({linksData: this.state.linksData})
    }

    removeNode = (nodeId) => {

        // reset event
        if (this.event.startNode) {
            this.event.startNode._refs.output.classed('.io-selected', false)
        }
        if (this.event.endNode) {
            this.event.endNode._refs.input.classed('.io-selected', false)
        }
        this.event = {
            startNode: undefined,
            endNode: undefined,
        }

        // get node
        var node = this.state.nodesData[this.state.nodesHashTable[nodeId]]

        // remove all links
        node.links.forEach(
            linkId => this.removeLink(this.state.linksData[this.state.linksHashTable[linkId]], true)
        )
        node.links = []

        var _id = this.state.nodesHashTable[nodeId]
        if (_id!=this.state.nodesData.length-1) {
            this.state.nodesData[_id] = this.state.nodesData[this.state.nodesData.length-1]
            this.state.nodesHashTable[this.state.nodesData[_id].id] = _id
        }
        this.state.nodesData.pop()

        this.setState({nodesData: this.state.nodesData}, ()=>{this.props.executeSearch()})
    }

    createLink = (skipSearch=false) => {
        this.event.startNode.links.push(this.linkCounter)
        this.event.endNode.links.push(this.linkCounter)

        this.state.linksData.push({
            id: this.linkCounter++,
            from_id: this.event.startNode.id,
            to_id: this.event.endNode.id,
            x1: this.event.startNode.outputX + this.event.startNode.x,
            y1: this.event.startNode.outputY + this.event.startNode.y,
            x2: this.event.endNode.inputX + this.event.endNode.x,
            y2: this.event.endNode.inputY + this.event.endNode.y,
        })

        // var sn = this.event.startNode
        // var en = this.event.endNode

        // this.moveNode(sn,0,0)
        // this.moveNode(en,0,0)

        this.event = {
            startNode: undefined,
            endNode: undefined,
        }

        this.state.linksHashTable[this.state.linksData[this.state.linksData.length-1].id] = this.state.linksData.length-1

        this.setState({linksData: this.state.linksData}, ()=>{
            if (skipSearch) {
                return
            }

            this.props.executeSearch()
        })
    }

    removeLink = (link, skipSearch=false) => {
        var linkId = link.id

        // izbaci link iz liste linkova od njegovog 'from' noda
        var fromNode = this.state.nodesData[this.state.nodesHashTable[link.from_id]]
        var purgedFromLinks = []
        fromNode.links.forEach(
            nodeLink => { if(nodeLink!=linkId) { purgedFromLinks.push(nodeLink) } }
        )
        fromNode.links = purgedFromLinks

        // izbaci link iz liste linkova od njegovog 'to' noda
        var toNode = this.state.nodesData[this.state.nodesHashTable[link.to_id]]
        var purgedToLinks = []
        toNode.links.forEach(
            nodeLink => { if(nodeLink!=linkId) { purgedToLinks.push(nodeLink) } }
        )
        toNode.links = purgedToLinks

        // izbaci link iz podataka
        var _id = this.state.linksHashTable[linkId]
        if (_id!=this.state.linksData.length-1) {
            this.state.linksData[_id] = this.state.linksData[this.state.linksData.length-1]
            this.state.linksHashTable[this.state.linksData[_id].id] = _id
        }
        this.state.linksData.pop()
        this.setState({
            linksData: this.state.linksData
        }, ()=>{
            if(!skipSearch) {
                this.props.executeSearch()
            }
        })
    }

    genExecutionList = () => {

        var startStack = []
        var opsStack = []
        var terminalStack = []

        // 1. add terminal nodes first:
        // zna se da su terminalni ako imaju samo input, bez outputa.
        // ili je terminalni i pocetni ako je matching operator koji nije povezan sa bilo cime (UX-friendly)
        this.state.nodesData.forEach(
            nodeItem => {
                nodeItem._executed = false
                nodeItem._recorded = false
                if (!nodeItem.hasOutput && nodeItem.hasInput && nodeItem.links.length>0) { terminalStack.push(nodeItem.id) }
                // else if (nodeItem.hasOutput && !nodeItem.hasInput && nodeItem.links.length===0) { startStack.push(nodeItem.id) }
            }
        )

        // 2. fill start and middle nodes:
        // rekurzivno pozivanje funkcije za posecivanje nodovih roditelja.
        // ukoliko trenutno posecivani roditelj ima i ulaz i izlaz, onda je middle.
        // ako ima samo izlaz, onda je startni node.

        // funkcija za posecivanje noda i roditelja
        var recordNode = (nodeId) => {
            var node = this.state.nodesData[this.state.nodesHashTable[nodeId]]
            node.links.forEach(
                linkId => {
                    var link = this.state.linksData[this.state.linksHashTable[linkId]]
                    if (link.to_id == node.id) {
                        var parentNodeId = link.from_id
                        var parentNode = this.state.nodesData[this.state.nodesHashTable[parentNodeId]]
                        if (!parentNode._recorded) {
                            // middle/op node
                            if (parentNode.hasInput && parentNode.hasOutput) {
                                opsStack.push(parentNodeId)
                                recordNode(parentNodeId)
                            }
                            // startni node
                            if (!parentNode.hasInput && parentNode.hasOutput) {
                                startStack.push(parentNodeId)
                                // nema posecivanja roditelja roditelja jer je startni
                            }
                            // obelezi ga da je posecen
                            parentNode._recorded = true
                        }
                    }
                }
            )
        }

        // kreni da posecujes roditelje od terminalnih nodova pa nadalje
        terminalStack.forEach(nodeId=>recordNode(nodeId))

        // console.log(`START ${startStack}`)
        // console.log(`MIDDL ${opsStack}`)
        // console.log(`TRMNL ${terminalStack}`)

        // 3. generisanje liste izvrsavanja
        if (startStack.length===0) {
            return []
        }

        var pendingStack = [...startStack, ...opsStack, ...terminalStack]
        var executedStack = []

        while (pendingStack.length > 0) {
            for (var pi=0; pi<pendingStack.length; pi++) {
                var pendingNode = this.state.nodesData[this.state.nodesHashTable[pendingStack[pi]]]

                // proveri da li su do sada zavrseni svi roditeljski nodovi
                var allParentsExecuted = true
                for (var pid=0; pid<pendingNode.links.length; pid++) {
                    var link = this.state.linksData[this.state.linksHashTable[pendingNode.links[pid]]]
                    if (link.to_id==pendingNode.id) {
                        if (this.state.nodesData[this.state.nodesHashTable[link.from_id]]._executed == false) {
                            allParentsExecuted = false
                            break
                        }
                    }
                }

                // ako su se zavrsili svi roditeljski nodovi, onda moze i ovaj node da se zvrsi
                if (allParentsExecuted) {
                    pendingNode._executed = true
                    executedStack.push(pendingNode.id)
                    pendingStack.splice(pi, 1)
                    pi--
                }
            }
        }

        return executedStack
    }

    getExecutionPlan = () => {
        var plan = []
        var exeList = this.genExecutionList()
        for (var i=0; i<exeList.length; i++) {
            var item = this.state.nodesData[this.state.nodesHashTable[exeList[i]]]
            var _inputs = []
            item.links.forEach(
                linkId => {
                    var link = this.state.linksData[this.state.linksHashTable[linkId]]
                    if (item.id == link.to_id) {
                        var exeIndex = exeList.indexOf(link.from_id)
                        if (exeIndex !== -1) {
                            _inputs.push(exeIndex)
                        }
                    }
                }
            )
            plan.push({
                type: item.type,
                value: item.value,
                fieldName: item.fieldName,
                inputs: _inputs,
                invert: item.invert
            })
        }
        return plan
    }

    createBasic = () => {
        // if (this.state.nodesData.length===0 && this.props.uberActive) {
        //     var m = this.createUberNode('match')
        //     m.x = 20
        //     m.y = 90
        //     var g = null
        //     g = this.createUberNode('group', ()=>{
        //         g.x = 320
        //         g.y = 90
        //         this.event.startNode = m
        //         this.event.endNode = g
        //         this.createLink()
        //     })
        // }
    }

    render() {

        this.createBasic()

        if (!this.props.uberActive) {
            return null
        }

        // console.log("<Uber> render")

        var links = this.state.linksData.map(
            link => <UberLink
                        key={link.id}
                        data={link}
                        removeLink={this.removeLink}
                    />
        )

        var nodes = this.state.nodesData.map(
            node => <UberNode
                        key={node.id}
                        data={node}
                        moveNode={this.moveNode}
                        event={this.event}
                        createLink={this.createLink}
                        testLinkage={this.testLinkage}
                        removeNode={this.removeNode}
                        templatesFieldList={this.props.templatesFieldList}
                        executeSearch={this.props.executeSearch}
                    />
        )

        return (
            <g ref={c=>this._refs.holder=c} >
                <g ref={c=>this._refs.links=c}>
                    {links}
                </g>
                <g ref={c=>this._refs.nodes=c}>
                    {nodes}
                </g>
            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Uber.js